import React, {useState, useEffect} from "react";
import {LocalType} from "app/types/common";

// Extend the Window interface to include __LOCALE__
declare global {
    interface Window {
        __LOCALE__?: string;
    }
}

// third-party
import {IntlProvider, MessageFormatElement} from "react-intl";
import {loadLocaleData} from "app/utils/locales";
import { useAppSelector } from "app/hooks/useAppSelector";
// import { useAppSelector } from "app/hooks/useAppSelector";
// import { getStore } from "app/store/storeAccessor";
// import {useAppSelector} from "hooks/useAppSelector";

// ==============================|| LOCALIZATION ||============================== //

interface LocalsProps {
    children: React.ReactNode;
}

const Locales = ({children, locale, messages}: any) => {
    const localeCurrent = useAppSelector((state) => state.config.locale);
    const [currentMessage, setMessages] = useState<Record<string, string> | Record<string, MessageFormatElement[]> | undefined>(messages);

    // console.log(getStore())

    useEffect(() => {
        loadLocaleData(localeCurrent).then((d: {default: Record<string, string> | Record<string, MessageFormatElement[]> | undefined}) => {
            setMessages(d.default);
        });
    }, [localeCurrent]);

    return (
        <>
            {/* {messages && ( */}
            <IntlProvider locale={locale} defaultLocale="en" messages={currentMessage}>
                {children}
            </IntlProvider>
            {/* )} */}
        </>
    );
};

export default Locales;
